import { Injectable } from '@angular/core';
import {first} from "rxjs/operators";
import {SharedDataService} from '../shared/shared.data.service';
import {TenantDataService} from "./tenant.data.service";

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  public staffs: any;

  constructor(
    private tenantDataService: TenantDataService
  ) {}

  getStaffs = (requestparam:any = {}) => {
   return this.tenantDataService.getStaffs(requestparam);
  }
  getActiveStaffs = (params: any = []) => {
   return this.tenantDataService.getActiveStaffs(params);
  }
}
